import { FormControl, MenuItem, TextField, withStyles } from '@material-ui/core';
import { SearchType } from 'connect/web/src/stores/search-store';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import type SearchBarStore from '../../stores/search-bar-store';
import styles from './styles';

interface IProps {
  className: string;
  searchBarStore?: SearchBarStore;
  classes: {
    locations: string;
  };
}

@inject('searchBarStore')
@observer
class Location extends React.Component<IProps> {
  render() {
    const { classes, searchBarStore } = this.props;

    const items = searchBarStore!.filteredLocations.map(({ onlineGuid, name }) => (
      <MenuItem value={onlineGuid}>{name}</MenuItem>
    ));

    return (
      <FormControl className={classes.locations}>
        <TextField
          select={true}
          label="Which Location?"
          value={searchBarStore!.locationId || 'All'}
          onChange={this.onChange}
          variant="outlined"
          fullWidth={true}
        >
          <MenuItem value={'All'}>All Locations</MenuItem>
          {items}
        </TextField>
      </FormControl>
    );
  }

  @action.bound
  onChange(e) {
    let { value } = e.target;
    const { searchBarStore } = this.props;

    searchBarStore!.locationId = value;

    const sId = searchBarStore!.serviceId.split('/')[0];

    if (!searchBarStore!.filteredServices.map((f) => f.id).includes(sId)) {
      searchBarStore!.serviceId = 'All';
    }

    if (!searchBarStore!.filteredTypes.includes(searchBarStore!.searchMode)) {
      searchBarStore!.searchMode = SearchType.Initial;
    }
  }
}

export default withStyles(styles)(Location);
